var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"manage-layouts-modal","centered":"","title":"Layouts","hide-footer":"","size":"xl"}},[_c('Table',{attrs:{"layouts":_vm.layouts,"withView":"","withDelete":_vm.withDelete},on:{"view":_vm.viewExpenses,"delete":_vm.deleteModal}}),_c('ExpensesModal',{attrs:{"expenses":_vm.layout?.expenses}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }